// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/normalize.css/normalize.css");
var ___CSS_LOADER_AT_RULE_IMPORT_1___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/@signavio/ui/assets/style.css");
var ___CSS_LOADER_AT_RULE_IMPORT_2___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/@signavio/ui/assets/fonts.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}
.hideOverflow {
  overflow: hidden;
}
html,
body {
  margin: 0;
  padding: 0;
}
body {
  background: var(--color-surface);
}
kbd {
  color: var(--color-mono-lighter);
  background: transparent;
  -ms-box-shadow: none 2px 0 rgba(0, 0, 0, 0.06);
  -o-box-shadow: none 2px 0 rgba(0, 0, 0, 0.06);
  box-shadow: none 2px 0 rgba(0, 0, 0, 0.06);
  -ms-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  display: inline-block;
  border: 1px solid var(--color-mono-lighter);
  padding: 0 4px;
  border-radius: 0;
}
a {
  color: var(--color-primary-base);
  outline: 0 !important;
  text-decoration: none;
  transition: color 0.3s ease;
}
a:visited {
  color: var(--color-primary-base);
  text-decoration: none;
}
a:hover,
a:focus,
a:active {
  color: var(--color-primary-variant);
  text-decoration: none;
}
q,
blockquote {
  quotes: '\\201C' '\\201D' '\\2018' '\\2019';
}
small {
  font-size: 12px;
  color: var(--color-mono-middle);
}
pre {
  margin: 0;
  border-radius: 0;
}
button {
  line-height: 1.5;
}
.view .view-header {
  position: relative;
  margin-top: 32px;
}
@media print {
  .view .view-header {
    margin-top: 0;
  }
}
.view .view-header .tabbed {
  margin-top: 32px;
}
.view .view-content {
  padding-top: 32px;
  margin-bottom: 320px;
}
input[type='text'],
input[type='url'],
input[type='password'],
input[type='number'],
input[type='email'],
input[type='date'],
input[type='datetime'],
select,
textarea {
  border-radius: 0;
  -ms-box-shadow: none 2px 0 rgba(0, 0, 0, 0.06);
  -o-box-shadow: none 2px 0 rgba(0, 0, 0, 0.06);
  box-shadow: none 2px 0 rgba(0, 0, 0, 0.06);
  -ms-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}
input[type='text'].legacy-input,
input[type='url'].legacy-input,
input[type='password'].legacy-input,
input[type='number'].legacy-input,
input[type='email'].legacy-input,
input[type='date'].legacy-input,
input[type='datetime'].legacy-input,
select.legacy-input,
textarea.legacy-input {
  font-weight: 400;
  font-family: 'Open Sans', sans-serif;
  color: var(--color-mono-ultradark);
  font-size: 16px;
  border: 1px solid var(--color-mono-lighter);
  padding: 0 15px;
  line-height: normal;
  min-height: 40px;
  font-size: 14px;
  transition: border-color ease-in-out 0.15s 0.3s ease;
  transition: box-shadow ease-in-out 0.15s 0.3s ease;
}
input[type='text'].legacy-input:focus,
input[type='url'].legacy-input:focus,
input[type='password'].legacy-input:focus,
input[type='number'].legacy-input:focus,
input[type='email'].legacy-input:focus,
input[type='date'].legacy-input:focus,
input[type='datetime'].legacy-input:focus,
select.legacy-input:focus,
textarea.legacy-input:focus {
  border-color: var(--color-primary-base);
  outline: 0;
}
input[type='text'].legacy-input[readonly='readonly'],
input[type='url'].legacy-input[readonly='readonly'],
input[type='password'].legacy-input[readonly='readonly'],
input[type='number'].legacy-input[readonly='readonly'],
input[type='email'].legacy-input[readonly='readonly'],
input[type='date'].legacy-input[readonly='readonly'],
input[type='datetime'].legacy-input[readonly='readonly'],
select.legacy-input[readonly='readonly'],
textarea.legacy-input[readonly='readonly'],
input[type='text'].legacy-input[readonly],
input[type='url'].legacy-input[readonly],
input[type='password'].legacy-input[readonly],
input[type='number'].legacy-input[readonly],
input[type='email'].legacy-input[readonly],
input[type='date'].legacy-input[readonly],
input[type='datetime'].legacy-input[readonly],
select.legacy-input[readonly],
textarea.legacy-input[readonly] {
  background-color: var(--color-mono-ultralight);
}
input[type='text'].legacy-input[readonly='readonly']:focus,
input[type='url'].legacy-input[readonly='readonly']:focus,
input[type='password'].legacy-input[readonly='readonly']:focus,
input[type='number'].legacy-input[readonly='readonly']:focus,
input[type='email'].legacy-input[readonly='readonly']:focus,
input[type='date'].legacy-input[readonly='readonly']:focus,
input[type='datetime'].legacy-input[readonly='readonly']:focus,
select.legacy-input[readonly='readonly']:focus,
textarea.legacy-input[readonly='readonly']:focus,
input[type='text'].legacy-input[readonly]:focus,
input[type='url'].legacy-input[readonly]:focus,
input[type='password'].legacy-input[readonly]:focus,
input[type='number'].legacy-input[readonly]:focus,
input[type='email'].legacy-input[readonly]:focus,
input[type='date'].legacy-input[readonly]:focus,
input[type='datetime'].legacy-input[readonly]:focus,
select.legacy-input[readonly]:focus,
textarea.legacy-input[readonly]:focus {
  border-color: var(--color-mono-lighter);
  -ms-box-shadow: none 2px 0 rgba(0, 0, 0, 0.06);
  -o-box-shadow: none 2px 0 rgba(0, 0, 0, 0.06);
  box-shadow: none 2px 0 rgba(0, 0, 0, 0.06);
  -ms-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}
label .context-help {
  line-height: 21px;
}
.form-control {
  width: 100%;
  padding: 9.5px 16px;
}
textarea.legacy-input {
  resize: vertical;
  padding: 9.5px 16px;
}
select.legacy-input {
  min-height: 0;
  padding: 0;
}
input[type='checkbox'].legacy-input {
  margin-right: 4px;
}
.form-group {
  margin-bottom: 1px;
}
.form-group.row {
  border-bottom: 1px solid var(--color-surface);
}
.form-control {
  border-radius: 0;
}
.container-header {
  position: relative;
  margin-bottom: 16px;
}
.container-header.clickable {
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
  cursor: pointer;
}
.container-header.clickable .toggle {
  position: absolute;
  top: 0;
  right: 0;
}
.accordion-item + .accordion-item {
  margin-top: 1px;
}
.accordion-item .collapsible-wrapper {
  background: var(--color-mono-ultralight);
  border-left: 1px solid var(--color-mono-lighter);
  border-right: 1px solid var(--color-mono-lighter);
  -ms-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.06);
  -o-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.06);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.06);
}
.accordion-item .collapsible-wrapper > .collapsible-body {
  padding: 16px;
}
.accordion-item .collapsible-expanded .collapsible-header {
  -ms-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.06);
  -o-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.06);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.06);
}
.accordion-item .collapsible-body {
  padding: 16px;
}
.accordion-item .collapsible-body .collapsible-content {
  padding: 16px;
  background: var(--color-surface);
}
.accordion-item .collapsible-header {
  position: relative;
}
.accordion-item .collapsible-header .title {
  cursor: pointer;
}
.accordion-item .collapsible-header .accordion-title {
  display: inline-block;
  width: 100%;
  padding: 0 16px;
}
.accordion-item .collapsible-header .accordion-title:hover {
  text-decoration: none;
}
.accordion-item .collapsible-header input {
  font-size: 16px;
}
.collapsible .collapsible-wrapper {
  overflow: hidden;
  transition: height 0.3s ease;
}
.collapsible .collapsible-header {
  position: relative;
  z-index: 1;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
table th {
  text-align: left;
}
table td,
table th {
  padding: 0;
}
.table td,
.table th {
  padding: 8px;
}
`, "",{"version":3,"sources":["webpack://./../commons/lib/less/index.less","webpack://./src/vendor.less","webpack://./../commons/lib/less/utils.less","webpack://./../commons/lib/less/view.less","webpack://./../commons/lib/less/forms.less","webpack://./../commons/lib/less/components/headings.less","webpack://./../commons/lib/less/components/accordion-item.less","webpack://./../commons/lib/less/components/collapsible.less","webpack://./../commons/lib/less/components/table.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;ACIF;ACgSA;EACE,gBAAA;AD9RF;AERA;;EAEE,SAAA;EACA,UAAA;AFUF;AEPA;EACE,gCAAA;AFSF;AENA;EACE,gCAAA;EACA,uBAAA;EDRA,8CAAA;EACA,6CAAA;EACA,0CAAA;EAFA,oBAAA;EACA,mBAAA;EACA,gBAAA;ECSA,qBAAA;EACA,2CAAA;EACA,cAAA;EDXA,gBAAA;ADmCF;AEnBA;EACE,gCAAA;EACA,qBAAA;EAEA,qBAAA;EDpBA,2BAAA;AD8CF;AEtBE;EACE,gCAAA;EACA,qBAAA;AFwBJ;AErBE;;;EAGE,mCAAA;EACA,qBAAA;AFuBJ;AEnBA;;EAEE,uCAAA;AFqBF;AElBA;EACE,eAAA;EACA,+BAAA;AFoBF;AEjBA;EACE,SAAA;EDhDA,gBAAA;ADyEF;AEpBA;EACE,gBAAA;AFsBF;AEnBA;EAEI,kBAAA;EAEA,gBAAA;AFmBJ;ACkBE;EAAA;IClCU,aAAA;EFoBV;AACF;AE5BA;EAWM,gBAAA;AFoBN;AE/BA;EAgBI,iBAAA;EAEA,oBAAA;AFiBJ;AGlGA;;;;;;;;;EFME,gBAAA;EAFA,8CAAA;EACA,6CAAA;EACA,0CAAA;EAFA,oBAAA;EACA,mBAAA;EACA,gBAAA;ADwHF;AGlHE;;;;;;;;;EFiMA,gBAAA;EACA,oCAAA;EACA,kCAAA;EACA,eAAA;EEjME,2CAAA;EAEA,eAAA;EAEA,mBAAA;EACA,gBAAA;EAEA,eAAA;EFhBF,oDAAA;EAAA,kDAAA;ADuJF;AGlII;;;;;;;;;EACE,uCAAA;EACA,UAAA;AH4IN;AGzII;;;;;;;;;;;;;;;;;;EAEE,8CAAA;AH2JN;AGzJM;;;;;;;;;;;;;;;;;;EACE,uCAAA;EFjCN,8CAAA;EACA,6CAAA;EACA,0CAAA;EAFA,oBAAA;EACA,mBAAA;EACA,gBAAA;ADuNF;AGhLA;EAEI,iBAAA;AHiLJ;AG7KA;EACE,WAAA;EACA,mBAAA;AH+KF;AG5KA;EACE,gBAAA;EACA,mBAAA;AH8KF;AG3KA;EACE,aAAA;EACA,UAAA;AH6KF;AG1KA;EACE,iBAAA;AH4KF;AGzKA;EACE,kBAAA;AH2KF;AGzKE;EACE,6CAAA;AH2KJ;AGvKA;EFxEE,gBAAA;ADuPF;AI3PA;EACE,kBAAA;EACA,mBAAA;AJ6PF;AI3PE;EHLA,yBAAA;EAIA,oBAAA;EACA,iBAAA;EGEE,eAAA;AJkQJ;AIpQE;EAKI,kBAAA;EAEA,MAAA;EACA,QAAA;AJiQN;AK/QA;EAEI,eAAA;ALgRJ;AKlRA;EAMI,wCAAA;EAEA,gDAAA;EACA,iDAAA;EJyBF,kDAAA;EACA,iDAAA;EACA,8CAAA;ADyPF;AK7RA;EAcM,aAAA;ALkRN;AKhSA;EJIE,2CAAA;EACA,0CAAA;EACA,uCAAA;ADkSF;AKxSA;EAyBI,aAAA;ALkRJ;AK3SA;EA4BM,aAAA;EAEA,gCAAA;ALiRN;AK/SA;EAmCI,kBAAA;AL+QJ;AKlTA;EJgQE,eAAA;ADqDF;AKrTA;EA0CM,qBAAA;EAEA,WAAA;EAEA,eAAA;AL4QN;AK1QM;EACE,qBAAA;AL4QR;AK7TA;EAsDM,eAAA;AL0QN;AMhUA;EAEQ,gBAAA;ELIN,4BAAA;ADmUF;AMzUA;EAQQ,kBAAA;EAEA,UAAA;ANmUR;AO7UA;EACE,yBAAA;EACA,iBAAA;AP+UF;AOjVA;EAKI,gBAAA;AP+UJ;AOpVA;;EAUI,UAAA;AP8UJ;AO1UA;;EAEI,YAAA;AP4UJ","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n@import 'colors';\n@import 'const';\n@import 'utils';\n@import 'view';\n@import 'forms';\n@import 'components';\n@import 'vendor';\n","@import 'normalize.css/normalize.css';\n\n@import '@signavio/ui/assets/style.css';\n@import '@signavio/ui/assets/fonts.css';\n\n@import '@signavio/effektif-commons/lib/less/index';\n",".quirks(@property, @value) {\n  -webkit-@{property}: @value;\n  -khtml-@{property}: @value;\n  -moz-@{property}: @value;\n  -ms-@{property}: @value;\n  -o-@{property}: @value;\n  @{property}: @value;\n}\n\n// the original value is not set in this mode\n// because this would break the functionality in most cases\n// when values are only valid in their prefixed form\n// then also other properties should only use this form\n.quirks-value(@property, @value) {\n  -webkit-@{property}: ~'-webkit-@{value}';\n  -khtml-@{property}: ~'-khtml-@{value}';\n  -moz-@{property}: ~'-moz-@{value}';\n  -ms-@{property}: ~'-ms-@{value}';\n  -o-@{property}: ~'-o-@{value}';\n}\n\n.quirks-value-prop(@property, @value) {\n  @{property}: ~'-webkit-@{value}';\n  @{property}: ~'-khtml-@{value}';\n  @{property}: ~'-moz-@{value}';\n  @{property}: ~'-ms-@{value}';\n  @{property}: ~'-o-@{value}';\n  @{property}: @value;\n}\n\n.quirks-append(@property, @value) {\n  -webkit-@{property}+: @value;\n  -khtml-@{property}+: @value;\n  -moz-@{property}+: @value;\n  -ms-@{property}+: @value;\n  -o-@{property}+: @value;\n  @{property}+: @value;\n}\n\n.quirks-append-space(@property, @value) {\n  -webkit-@{property}+_: @value;\n  -khtml-@{property}+_: @value;\n  -moz-@{property}+_: @value;\n  -ms-@{property}+_: @value;\n  -o-@{property}+_: @value;\n  @{property}+_: @value;\n}\n\n.keyframes(@name, @rules) {\n  @-webkit-keyframes @name {\n    @rules();\n  }\n  @-khtml-keyframes @name {\n    @rules();\n  }\n  @-moz-keyframes @name {\n    @rules();\n  }\n  @-ms-keyframes @name {\n    @rules();\n  }\n  @-o-keyframes @name {\n    @rules();\n  }\n  @keyframes @name {\n    @rules();\n  }\n}\n\n.placeholder(@component, @rules) {\n  @{component}::-webkit-input-placeholder {\n    @rules();\n  }\n  @{component}::-khtml-input-placeholder {\n    @rules();\n  }\n  @{component}::-moz-input-placeholder {\n    @rules();\n  }\n  @{component}:-moz-input-placeholder {\n    @rules();\n  }\n  @{component}::-ms-input-placeholder {\n    @rules();\n  }\n  @{component}::-o-input-placeholder {\n    @rules();\n  }\n  @{component}::input-placeholder {\n    @rules();\n  }\n}\n\n@screen-xs-max: 767;\n@screen-sm-max: 991;\n@screen-md-max: 1199;\n\n.media-helper(@size, @rules) {\n  @media (~'max-width: @{screen-@{size}-max}') {\n    @rules();\n  }\n}\n\n.print(@rules) {\n  @media print {\n    @rules();\n  }\n}\n\n.xs(@rules) {\n  .media-helper(xs, @rules);\n}\n\n.sm(@rules) {\n  .media-helper(sm, @rules);\n}\n\n.md(@rules) {\n  .media-helper(md, @rules);\n}\n\n.lg(@rules) {\n  .media-helper(lg, @rules);\n}\n\n.transform(@value:rotate(0deg)) {\n  .quirks-append-space(transform, @value);\n}\n\n.transition(@value: all, @kind: ease, @speed: 0.3s) {\n  .quirks(transition, @value @speed @kind);\n}\n\n.transition-prefix(@value: all, @kind: ease, @speed: 0.3s) {\n  .quirks-value(transition, @value @speed @kind);\n}\n\n.transition-append(@value, @kind: ease, @speed: 0.3s) {\n  .quirks-append(transition, @value @speed @kind);\n}\n\n.border-radius(@value: 0px) {\n  .quirks(border-radius, @value);\n}\n\n.animation(@value) {\n  .quirks(animation, @value);\n}\n\n.user-select(@value) {\n  .quirks(user-select, @value);\n}\n\n.word-break(@value, @chrome: false)\n  when\n  (@value = break-all)\n  and\n  (@chrome = true) {\n  word-break: break-word;\n}\n\n.word-break(@value: break-all) {\n  .quirks(word-break, @value);\n\n  .word-break(@value, @chrome: true);\n}\n\n.hyphens(@value: auto) {\n  .quirks(hyphens, @value);\n}\n\n.filter(@value) {\n  .quirks(filter, @value);\n}\n\n.icon(@color: white) {\n  display: inline-block;\n\n  width: @icon-width;\n  height: @icon-height;\n\n  color: @color;\n\n  border-radius: 0;\n\n  line-height: @icon-line-height - 1;\n\n  background-color: var(--color-mono-lighter);\n\n  text-align: center;\n}\n\n.signavio-icon(@color: white) {\n  .icon(@color);\n\n  font-family: @icon-font-signavio;\n}\n\n.ellipsis() {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.font() {\n  font-weight: @font-weight;\n  font-family: @font-face-text;\n  color: var(--color-mono-ultradark);\n  font-size: @font-size;\n}\n\n.box-shadow(@left: 2px, @top: 2px, @spread: 0, @color: @shadow-color) {\n  .quirks(box-shadow, @arguments);\n}\n\n.box-shadow(@left: 2px, @top: 2px, @spread: 0, @color: @shadow-color)\n  when\n  (@left = none) {\n  .quirks(box-shadow, none);\n}\n\n.box-shadow-inset(@left: 2px, @top: 2px, @spread: 0, @color: @shadow-color) {\n  .quirks-append(box-shadow, inset @arguments);\n}\n\n.no-box-shadow() {\n  .quirks(box-shadow, none);\n}\n\n.inset-shadow(@left: 2px, @top: 2px) {\n  @value: @left @top 0 @shadow-color;\n\n  .quirks(box-shadow, inset @value);\n}\n\n.popover-base(@shadow-offset: 2px) {\n  border: 1px solid var(--color-mono-lighter);\n\n  max-width: none;\n\n  .border-radius(0);\n  .box-shadow(@shadow-offset, @shadow-offset);\n\n  h1 {\n    margin: @component-padding 0;\n    padding: 0;\n\n    font-size: 1.5 * @font-size;\n  }\n}\n\n.hover(@color, @property: background) {\n  @{property}: darken(@color, 10%);\n}\n\n.pointer() {\n  cursor: pointer;\n}\n\n.separator(@location: top, @padding: @component-padding, @style: dotted) {\n  margin-@{location}: @padding;\n  padding-@{location}: @padding;\n\n  border-@{location}: 1px @style var(--color-mono-lighter);\n}\n\n.pointer-events(@value: none) {\n  .quirks(pointer-events, @value);\n}\n\n.grayscale(@amount: 100%) {\n  filter: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale\"); /* Firefox 10+, Firefox on Android */\n  filter: gray; /* IE6-9 */\n\n  .filter(grayscale(@amount));\n}\n\n.multiline-form-line-height(@clear-line-height: @clear-line-height*@font-size, @form-line-height: @form-line-height) {\n  line-height: @clear-line-height;\n  padding-top: ((@form-line-height - @clear-line-height) / 2);\n  padding-bottom: ((@form-line-height - @clear-line-height) / 2);\n}\n\n.flip-horizontal() {\n  .transform(scaleX(-1));\n\n  .quirks(filter, fliph);\n}\n\n.blur(@spread: 10px) {\n  .filter(blur(@spread));\n}\n\n.hideOverflow {\n  overflow: hidden;\n}\n\n.link-color(@color) {\n  a {\n    color: @color;\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:visited {\n      color: @color;\n    }\n  }\n}\n\n.gradient(@direction, @from, @to) {\n  .quirks-value-prop(background-image, @arguments);\n}\n\n.text-color(@background, @darken: 40%, @lighten: 50%) {\n  @new-text-color: contrast(\n    @background,\n    darken(@background, @darken),\n    lighten(@background, @lighten)\n  );\n\n  color: @new-text-color;\n\n  .link-color(@new-text-color);\n}\n","html,\nbody {\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  background: var(--color-surface);\n}\n\nkbd {\n  color: var(--color-mono-lighter);\n  background: transparent;\n  .box-shadow(none);\n\n  display: inline-block;\n  border: 1px solid var(--color-mono-lighter);\n  padding: 0 @component-padding-xsmall;\n\n  .border-radius(0);\n}\n\na {\n  color: var(--color-primary-base);\n  outline: 0 !important;\n\n  text-decoration: none;\n\n  .transition(color);\n\n  &:visited {\n    color: var(--color-primary-base);\n    text-decoration: none;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: var(--color-primary-variant);\n    text-decoration: none;\n  }\n}\n\nq,\nblockquote {\n  quotes: '\\201C''\\201D''\\2018''\\2019';\n}\n\nsmall {\n  font-size: @font-size-small;\n  color: var(--color-mono-middle);\n}\n\npre {\n  margin: 0;\n\n  .border-radius(0);\n}\n\nbutton {\n  line-height: 1.5;\n}\n\n.view {\n  .view-header {\n    position: relative;\n\n    margin-top: @component-padding-large;\n\n    .print({\n            margin-top: 0;\n        });\n\n    .tabbed {\n      margin-top: @component-padding-large;\n    }\n  }\n\n  .view-content {\n    padding-top: @component-padding-large;\n\n    margin-bottom: 10 * @component-padding-large;\n  }\n}\n","input[type='text'],\ninput[type='url'],\ninput[type='password'],\ninput[type='number'],\ninput[type='email'],\ninput[type='date'],\ninput[type='datetime'],\nselect,\ntextarea {\n  .border-radius(0);\n  .box-shadow(none);\n\n  &.legacy-input {\n    .font();\n\n    border: 1px solid var(--color-mono-lighter);\n\n    padding: @text-input-padding;\n\n    line-height: normal;\n    min-height: @form-line-height;\n\n    font-size: @font-size-form-field;\n\n    .transition(border-color ease-in-out 0.15s);\n    .transition(box-shadow ease-in-out 0.15s);\n\n    &:focus {\n      border-color: var(--color-primary-base);\n      outline: 0;\n    }\n\n    &[readonly='readonly'],\n    &[readonly] {\n      background-color: var(--color-mono-ultralight);\n\n      &:focus {\n        border-color: var(--color-mono-lighter);\n\n        .box-shadow(none);\n      }\n    }\n  }\n}\n\nlabel {\n  .context-help {\n    line-height: (@context-help-size + 1);\n  }\n}\n\n.form-control {\n  width: 100%;\n  padding: @text-padding @component-padding;\n}\n\ntextarea.legacy-input {\n  resize: vertical;\n  padding: @text-padding @component-padding;\n}\n\nselect.legacy-input {\n  min-height: 0;\n  padding: 0;\n}\n\ninput[type='checkbox'].legacy-input {\n  margin-right: @component-padding-xsmall;\n}\n\n.form-group {\n  margin-bottom: 1px;\n\n  &.row {\n    border-bottom: 1px solid var(--color-surface);\n  }\n}\n\n.form-control {\n  .border-radius(0);\n}\n","\n\n.container-header {\n  position: relative;\n  margin-bottom: @component-padding;\n\n  &.clickable {\n    .user-select(none);\n    cursor: pointer;\n\n    .toggle {\n      position: absolute;\n\n      top: 0;\n      right: 0;\n    }\n  }\n}\n\n\n",".accordion-item {\n  + .accordion-item {\n    margin-top: 1px;\n  }\n\n  .collapsible-wrapper {\n    background: var(--color-mono-ultralight);\n\n    border-left: 1px solid var(--color-mono-lighter);\n    border-right: 1px solid var(--color-mono-lighter);\n\n    .box-shadow-inset(@left: 0, @top: -1px);\n\n    > .collapsible-body {\n      padding: @component-padding;\n    }\n  }\n\n  .collapsible-expanded {\n    .collapsible-header {\n      .box-shadow(0);\n    }\n  }\n\n  .collapsible-body {\n    padding: @component-padding;\n\n    .collapsible-content {\n      padding: @component-padding;\n\n      background: var(--color-surface);\n    }\n  }\n\n  .collapsible-header {\n    position: relative;\n\n    .title {\n      .pointer();\n    }\n\n    .accordion-title {\n      display: inline-block;\n\n      width: 100%;\n\n      padding: 0 @component-padding;\n\n      &:hover {\n        text-decoration: none;\n      }\n    }\n\n    input {\n      font-size: @font-size;\n    }\n  }\n}\n",".collapsible {\n    .collapsible-wrapper {\n        overflow: hidden;\n\n        .transition(height);\n    }\n\n    .collapsible-header {\n        position: relative;\n\n        z-index: 1;\n    }\n}\n","table {\n  border-collapse: collapse;\n  border-spacing: 0;\n\n  th {\n    text-align: left;\n  }\n\n  td,\n  th {\n    padding: 0;\n  }\n}\n\n.table {\n  td,th {\n    padding: @component-padding-small;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
